<template>
  <PageView title="专家年度评价">
    <template slot="action">
      <a-button-group>
        <a-button
            class="intro-JiGuanShiWu-add" introKey="JiGuanShiWu-add"
            @click="onAdd"
            type="primary"
            icon="plus"
        >
          登记
        </a-button>
      </a-button-group>
    </template>
    <ExpertYearAssessSTable :isManager="isManager"/>
  </PageView>
</template>

<script>
import ExpertYearAssessSTable from '@/epp/expertmain/expertyearassess/common/ExpertYearAssessSTable'
import { PageView } from '@/layouts'
export default {
  name: 'ExpertYearAssessIndex',
  components: {
    PageView,
    ExpertYearAssessSTable },
  data () {
    return {
      isManager: false
    }
  },
  methods: {
    onAdd () {
      this.$router.push({ path: '/expertYearAssess/add' })
    }
  }
}
</script>

<style scoped>

</style>
